/** Miquinhas brand palette */
export const palette = {
  primary: "#7D7561",
  secondary: "#E4DBC7",
  background: "#F5F5F5",
  dark: "#262626",
  accent: "#C96B2E",
  accentDark: "#A8561F",
  accentLight: "#E8A066",
  white: "#FFFFFF",
}

/** RGB channels for rgba() composition */
export const rgb = {
  primary: "125, 117, 97",
  secondary: "228, 219, 199",
  dark: "38, 38, 38",
  accent: "201, 107, 46",
  white: "255, 255, 255",
}

/** Pre-composed translucent surfaces */
export const alpha = {
  /** Full-page menu: beige tint + backdrop blur */
  menuOverlay: `rgba(${rgb.secondary}, 0.55)`,
  menuOverlayLight: `rgba(${rgb.secondary}, 0.42)`,
}

/** Build rgba from a palette key or raw channels */
export const withAlpha = (channels, opacity) =>
  `rgba(${channels}, ${opacity})`

/** CMS page_settings.background aliases → palette keys */
export const pageBackgroundMap = {
  default: "background",
  background: "background",
  cream: "secondary",
  beige: "secondary",
}

/** page_settings.background (ACF select) → CSS color */
export const resolvePageBackground = (value) => {
  if (!value) return palette.background
  if (value.startsWith("#")) return value

  const key = value.toLowerCase()
  const paletteKey = pageBackgroundMap[key] || key

  return palette[paletteKey] || palette.background
}

/** Derived tokens for components & MUI */
export const branding = {
  primary: palette.primary,
  secondary: palette.secondary,
  background: palette.background,
  muted: palette.secondary,
  text: palette.dark,
  active: "#635C4D",
  accent: palette.accent,
  accentActive: palette.accentDark,
  accentLight: palette.accentLight,
  black: palette.dark,
  white: palette.white,
}

/** Neutral scale anchored to brand colors */
export const neutral = {
  neu01: palette.background,
  neu02: palette.secondary,
  neu03: "#D4CCBA",
  neu04: "#B5ACA0",
  neu05: "#969088",
  neu06: palette.primary,
  neu07: "#5F5849",
  neu08: "#454038",
  neu09: "#353130",
  neu10: palette.dark,
}

export const common = {
  success: "#28a745",
  warning: "#ffc107",
  error: "#dc3545",
}

export const white = palette.white
export const black = { default: palette.dark }
export const red = { default: common.error }

export default palette
